const { ccclass } = cc._decorator;
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../framework/core/mvvm/module_base";
import ModuleManager from "../../../framework/core/module_manager";
import DialogTips from "../../public/module/dialog_tips/dialog_tips";
import ModelData from "../../public/model_data";
import ClubShareView from "./club_share_view";
import SdkManager from "../../../manager/sdk_manager";
import SdkDefine from "../../../sdk/collection/sdk_define";
import AppController from "../../../sdk/app_controller";

@ccclass
@moduleInit("ClubShare")
export default class ClubShare extends ModuleBase<ClubShareView, null>  {
    promoteUrl = null
    clubShareData : {clubId : number, clubCode : number} = null
    constructor() {
        super()
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = 'package/club/module/clubShare_table';       
        this.viewType = ClubShareView;
        this.needAnim = true
        this.autoShowAnim = true
        this.needViewMask = true
    }

    onShow(intentData) {
        this.clubShareData = intentData
        this.getPromoteAD()
    }


    protected onButtonClickName(name : string) {
        switch (name) {
            case "BackBtn":
                ModuleManager.instance.hideModule("ClubShare")
                break;
            case "FbBtn":
                this.share(SdkDefine.FACE_BOOK_NAME);
                break;
            case "LineBtn":
                this.share(SdkDefine.LINE_NAME);
                break;
            default:
                break;
        }
    }

    share(shareName){
        if (this.promoteUrl == null){ return }
        let content
        if (cc.sys.isNative) {
            content = { "text":  this.promoteUrl };
        } else if (cc.sys.isBrowser) {
            content = { "link":  this.promoteUrl };
        }
        SdkManager.instance.req_share(shareName, content);
        ModuleManager.instance.hideModule("ClubShare")
        this.buriedPoint()
    }
    // @bindButtonClickEvent("btnShareLine")
    // btnShareLine() {
    //     this.shareChannel = "Line"
    //     this.share(SdkDefine.LINE_NAME)
    // }
    // @bindButtonClickEvent("btnShareFacebook")
    // btnShareFacebook() {
    //     this.shareChannel = "Facebook"
    //     this.share(SdkDefine.FACE_BOOK_NAME)
    // }

    // share(sdkname) {
    //     if (this.shareContent) {
    //         this.shareStatus = 1
    //         SdkManager.instance.req_share(sdkname, this.shareContent);
    //     }
    // }

    //推广图片数据
    getPromoteAD() {
        
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "promoters/promotionIndex?",
        }
        this.apiHttpGet(requestData, function (retData) {
            self.promoteUrl = retData.data.qrcode + "?inviteCode=" + `${retData.data.inviteCode}-${self.clubShareData.clubCode}-${self.clubShareData.clubId}`
            // self.promoteUrl = encodeURI(self.promoteUrl) 
            AppController.instance.copyTextToClipboard(self.promoteUrl)
            cc.log("分享链接：",self.promoteUrl)
        })
    }

    //推广埋点
    buriedPoint() {
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "commons/buriedPoint?",
            params: {
                clubUserIdShare:self.clubShareData.clubCode,
            },
        }
        this.apiHttpGet(requestData, function (retData) {
        })
    }

        

}